import * as React from "react";
import { Moment } from "moment";

import { Table } from "semantic-ui-react";

import { TableDetail } from "./TableDetail";

interface Props {
    name: string;
    dateOfBirth: Moment;
    jobTitle: string;
    workGroups: string[];
}

const EmployeeDetails: React.FunctionComponent<Props> = (props) => {
    return (
        <Table>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>
                        Details
                    </Table.HeaderCell>
                    <Table.HeaderCell />
                </Table.Row>
            </Table.Header>
            <Table.Body>
                <TableDetail name="Name" value={props.name} />
                <TableDetail name="Date of Birth" value={props.dateOfBirth?.format("DD/MM/YYYY")} />
                <TableDetail name="Job Role" value={props.jobTitle} />
                <TableDetail name="Exposure Group" value={props.workGroups.join(", ")} />
            </Table.Body>
        </Table>
    );
};

export { EmployeeDetails };
